<template>
  <div class="login" :class="{ 'is-day': sceneTheme === 'day' }">
    <div class="scene" aria-hidden="true">
      <div class="aurora aurora-a"></div>
      <div class="aurora aurora-b"></div>
      <div class="grid"></div>
      <canvas ref="fxCanvas" class="fx-canvas"></canvas>
      <div class="floor"></div>
      <div class="scanline"></div>
      <div class="stage-wrap">
        <svg class="stage" viewBox="0 0 760 520" preserveAspectRatio="xMidYMid meet">
          <defs>
            <linearGradient id="ptCrateCyan" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stop-color="#67e8f9"/>
              <stop offset="1" stop-color="#0284c7"/>
            </linearGradient>
            <linearGradient id="ptCrateAmber" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stop-color="#fcd34d"/>
              <stop offset="1" stop-color="#d97706"/>
            </linearGradient>
          </defs>
          <g class="racks" fill="none" stroke="rgba(125,211,252,0.45)" stroke-width="1.4">
            <g transform="translate(36,78)">
              <rect width="168" height="236" rx="8" fill="rgba(4,14,30,0.55)"/>
              <path d="M0 60H168M0 118H168M0 176H168"/>
              <rect class="beam b1" x="6" y="8" width="156" height="6" rx="2"/>
            </g>
            <g transform="translate(220,78)">
              <rect width="168" height="236" rx="8" fill="rgba(4,14,30,0.55)"/>
              <path d="M0 60H168M0 118H168M0 176H168"/>
              <rect class="beam b2" x="6" y="8" width="156" height="6" rx="2"/>
            </g>
            <g transform="translate(404,78)">
              <rect width="168" height="236" rx="8" fill="rgba(4,14,30,0.55)"/>
              <path d="M0 60H168M0 118H168M0 176H168"/>
              <rect class="beam b3" x="6" y="8" width="156" height="6" rx="2"/>
            </g>
          </g>
          <g class="crates">
            <rect class="crate" x="52" y="96" width="40" height="30" rx="3" fill="url(#ptCrateCyan)"/>
            <rect class="crate" x="104" y="98" width="40" height="28" rx="3" fill="url(#ptCrateAmber)"/>
            <rect class="crate" x="58" y="156" width="52" height="28" rx="3" fill="url(#ptCrateCyan)"/>
            <rect class="crate" x="246" y="96" width="44" height="30" rx="3" fill="url(#ptCrateAmber)"/>
            <rect class="crate" x="304" y="154" width="48" height="28" rx="3" fill="url(#ptCrateCyan)"/>
            <rect class="crate" x="430" y="154" width="46" height="30" rx="3" fill="url(#ptCrateAmber)"/>
            <rect class="crate" x="492" y="96" width="50" height="28" rx="3" fill="url(#ptCrateCyan)"/>
            <rect class="crate" x="448" y="214" width="40" height="26" rx="3" fill="url(#ptCrateAmber)"/>
          </g>
          <g transform="translate(36,348)">
            <rect width="536" height="22" rx="6" fill="rgba(8,30,52,0.9)" stroke="rgba(34,211,238,0.55)"/>
            <line class="belt-dash" x1="12" y1="11" x2="524" y2="11" stroke="rgba(125,211,252,0.7)" stroke-width="2" stroke-dasharray="16 12"/>
            <rect class="parcel" x="8" y="-26" width="36" height="24" rx="3" fill="url(#ptCrateCyan)"/>
            <rect class="parcel d2" x="8" y="-26" width="28" height="24" rx="3" fill="url(#ptCrateAmber)"/>
            <rect class="parcel d3" x="8" y="-26" width="42" height="24" rx="3" fill="url(#ptCrateCyan)"/>
          </g>
          <g class="robot">
            <ellipse cx="48" cy="122" rx="26" ry="6" fill="rgba(34,211,238,0.28)" stroke="none"/>
            <rect x="24" y="52" width="48" height="54" rx="12" fill="#071525" stroke="#67e8f9" stroke-width="1.6"/>
            <circle class="core" cx="48" cy="78" r="7" fill="#22d3ee" stroke="none"/>
            <rect x="30" y="20" width="36" height="28" rx="8" fill="#071525" stroke="#7dd3fc" stroke-width="1.6"/>
            <rect class="visor" x="36" y="30" width="24" height="8" rx="3" fill="#22d3ee" stroke="none"/>
            <line x1="48" y1="20" x2="48" y2="8" stroke="#67e8f9" stroke-width="1.6"/>
            <circle cx="48" cy="6" r="3" fill="#a5f3fc" stroke="none"/>
            <g class="arm">
              <rect x="72" y="64" width="26" height="7" rx="3" fill="#0e7490" stroke="#a5f3fc" stroke-width="1"/>
              <rect x="94" y="58" width="12" height="18" rx="2" fill="#155e75" stroke="#67e8f9"/>
            </g>
            <rect x="30" y="104" width="14" height="10" rx="2" fill="#164e63" stroke="none"/>
            <rect x="52" y="104" width="14" height="10" rx="2" fill="#164e63" stroke="none"/>
          </g>
          <g class="radar" transform="translate(650,64)" stroke="#67e8f9" fill="none">
            <circle r="40" stroke-opacity="0.35"/>
            <circle r="24" stroke-opacity="0.28"/>
            <circle r="8" stroke-opacity="0.5"/>
            <g class="sweep-arm">
              <line x1="0" y1="0" x2="40" y2="0" stroke="#22d3ee" stroke-width="1.6"/>
            </g>
          </g>
          <g class="truck" stroke="#7dd3fc" stroke-width="1.3">
            <rect x="0" y="0" width="78" height="32" rx="3" fill="#082f49"/>
            <rect x="10" y="6" width="22" height="16" rx="2" fill="#0ea5e9" stroke="none" opacity="0.85"/>
            <rect x="38" y="6" width="22" height="16" rx="2" fill="#f59e0b" stroke="none" opacity="0.9"/>
            <path d="M78 10 H98 L108 22 V32 H78 Z" fill="#0c4a6e"/>
            <circle cx="22" cy="36" r="5" fill="#22d3ee" stroke="none"/>
            <circle cx="64" cy="36" r="5" fill="#22d3ee" stroke="none"/>
            <circle cx="96" cy="36" r="5" fill="#22d3ee" stroke="none"/>
          </g>
        </svg>
      </div>
      <div class="vignette"></div>
    </div>
    <div class="story">
      <div class="eyebrow">物流 · 仓库 · 机器人</div>
      <h2>货在仓里、在途中<br>也在机器人手里</h2>
      <p>下单、入仓、查件，和仓库协同在同一块屏。</p>
      <div class="hud">
        <div><em>入仓</em><strong>扫码上架</strong></div>
        <div><em>AGV</em><strong>分拣待命</strong></div>
        <div><em>运单</em><strong>在途可视</strong></div>
      </div>
    </div>
    <div class="main-shell">
      <div class="shell-spin"></div>
      <div class="main-box">
        <div class="brand">
          <div class="logo-plate" v-if="logoUrl">
            <img :src="logoUrl" alt="" />
          </div>
          <div class="logo-mark" v-else>
            <svg viewBox="0 0 64 64" aria-hidden="true">
              <rect x="14" y="28" width="36" height="26" rx="8" fill="none" stroke="#67e8f9" stroke-width="2"/>
              <circle cx="32" cy="41" r="4" fill="#22d3ee"/>
              <rect x="20" y="12" width="24" height="16" rx="5" fill="none" stroke="#7dd3fc" stroke-width="2"/>
              <rect x="26" y="17" width="12" height="5" rx="2" fill="#22d3ee"/>
              <line x1="32" y1="12" x2="32" y2="6" stroke="#67e8f9" stroke-width="2"/>
              <circle cx="32" cy="5" r="2" fill="#a5f3fc"/>
            </svg>
          </div>
          <h1>{{ title || '客户门户' }}</h1>
          <div class="status"><i></i>链路在线 · 客户通道</div>
        </div>
      <div class="main-login">
        <!-- 用户登录 -->
        <div class="userLogin">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <!-- 账号 -->
            <el-form-item prop="tel">
              <el-input
                size="medium"
                type="text"
                v-model.trim="ruleForm.tel"
                prefix-icon="el-icon-user-solid"
                autocomplete="off"
                placeholder="请输入客户代码"
                @keyup.enter.native="submitLogin('ruleForm')"
              ></el-input>
            </el-form-item>
            <!-- 密码 -->
            <el-form-item prop="pass">
              <el-input
                type="password"
                size="medium"
                v-model.trim="ruleForm.pass"
                prefix-icon="el-icon-lock"
                show-password
                autocomplete="off"
                placeholder="密码"
                @keyup.enter.native="submitLogin('ruleForm')"
              ></el-input>
            </el-form-item>
            <!-- 登录按钮 -->
            <el-form-item class="form-item">
              <el-button type="primary" @click="submitLogin('ruleForm')" size="medium">登录</el-button>
            </el-form-item>
            <!-- 注册 -->
            <div class="registered">
                <el-tooltip class="item" effect="dark" content="请联系系统管理员或业务" placement="top-start">
                    <div class="registered_left">无法登录？</div>
                </el-tooltip>
                <el-link
                  v-if="wxConfigAvailable"
                  type="primary"
                  :underline="false"
                  @click="openWxLoginDialog"
                  class="registered_r">
                  微信登录
                </el-link>
            </div>
          </el-form>
        </div>
        <!-- 短信验证 -->
      </div>
    </div>
    </div>
    <el-dialog
      :visible.sync="msgDialogVisible"
      :custom-class="sceneTheme === 'day' ? 'wx-login-dialog is-day' : 'wx-login-dialog'"
      append-to-body
      width="360px"
      top="10vh"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
    >
      <div slot="title" class="wx-login-title" :class="{ 'is-day': sceneTheme === 'day' }">
        <span class="wx-dot"></span>
        <div>
          <strong>微信登录</strong>
          <em>打开微信，扫一扫</em>
        </div>
      </div>
      <div class="wx-login-frame" v-if="msgDialogVisible && wxConfigAvailable">
        <span class="wx-login-loading">二维码加载中</span>
        <Wxlogin
          id="wxLoginForm"
          :appid="appid"
          :scope="scope"
          :redirect_uri="redirect_uri"
          theme="black"
        ></Wxlogin>
      </div>
      <div v-else-if="msgDialogVisible" class="wx-config-error">
        微信扫码暂未开通，请联系管理员配置网站应用
      </div>
    </el-dialog>
    <div class="footer">
      <p v-if="record">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">{{ record }}</a>
      </p>
      <p v-if="company">© {{ copyrightYear }} {{ company }} 版权所有</p>
    </div>
  </div>
</template>
<script>
//引入api
import httpApi from "@/http/api";
import { applyDocumentTitle, saveSysBrand } from "@/utils/sysBrand";

import Wxlogin from "vue-wxlogin"

function pickWebsiteWeiXin(list) {
  return (list || []).find(row => (row.wxType || "").trim() === "website") || null;
}

function sceneThemeByHour(date) {
  const hour = (date || new Date()).getHours();
  return hour >= 6 && hour < 18 ? "day" : "night";
}

export default {
  components: {
    Wxlogin // 声明引用组件
  },
  data() {
    //正则账号验证
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    //正则密码验证
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      appid: "", // 应用唯一标识，在微信开放平台提交应用审核通过后获得
      scope: "snsapi_login", // 应用授权作用域，网页应用目前仅填写snsapi_login即可
      redirect_uri: "", // 重定向地址 （回调地址）
      msgDialogVisible: false,
      wxConfigAvailable: false, // 微信配置是否可用
      logoUrl: "",
      title: "",
      sceneTheme: sceneThemeByHour(),
      record: "",
      company: "",
      ruleForm: {
        //账号
        tel: "",
        //密码
        pass: ""
      },
      //正则
      rules: {
        tel: [{ validator: validatePass, trigger: "blur" }],
        pass: [{ validator: validatePass2, trigger: "blur" }]
      },
      code:""
    };
  },
  computed: {
    copyrightYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    syncSceneTheme() {
      this.sceneTheme = sceneThemeByHour();
    },
    startScene() {
      const canvas = this.$refs.fxCanvas;
      if (!canvas || !canvas.parentElement) return;
      const ctx = canvas.getContext("2d");
      if (!ctx) return;
      const host = canvas.parentElement;
      const dots = [];
      const resize = () => {
        const w = host.clientWidth || window.innerWidth;
        const h = host.clientHeight || window.innerHeight;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.max(1, Math.floor(w * dpr));
        canvas.height = Math.max(1, Math.floor(h * dpr));
        canvas.style.width = w + "px";
        canvas.style.height = h + "px";
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        if (!dots.length) {
          const n = w < 800 ? 28 : 46;
          for (let i = 0; i < n; i++) {
            dots.push({
              x: Math.random() * w,
              y: Math.random() * h,
              vx: (Math.random() - 0.5) * 0.32,
              vy: (Math.random() - 0.5) * 0.32,
              r: Math.random() * 1.5 + 0.4
            });
          }
        }
      };
      const tick = () => {
        const w = host.clientWidth || window.innerWidth;
        const h = host.clientHeight || window.innerHeight;
        ctx.clearRect(0, 0, w, h);
        for (let i = 0; i < dots.length; i++) {
          const d = dots[i];
          d.x += d.vx;
          d.y += d.vy;
          if (d.x < 0 || d.x > w) d.vx *= -1;
          if (d.y < 0 || d.y > h) d.vy *= -1;
          ctx.beginPath();
          ctx.fillStyle = (host.closest(".login") && host.closest(".login").classList.contains("is-day"))
            ? "rgba(3, 105, 161, 0.55)"
            : "rgba(125, 211, 252, 0.8)";
          ctx.arc(d.x, d.y, d.r, 0, Math.PI * 2);
          ctx.fill();
          for (let j = i + 1; j < dots.length; j++) {
            const o = dots[j];
            const dx = d.x - o.x;
            const dy = d.y - o.y;
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist < 130) {
              const dayDots = host.closest(".login") && host.closest(".login").classList.contains("is-day");
              ctx.strokeStyle = (dayDots ? "rgba(2, 132, 199," : "rgba(56, 189, 248,") + (0.22 * (1 - dist / 130)).toFixed(3) + ")";
              ctx.lineWidth = 1;
              ctx.beginPath();
              ctx.moveTo(d.x, d.y);
              ctx.lineTo(o.x, o.y);
              ctx.stroke();
            }
          }
        }
        this._fxRaf = requestAnimationFrame(tick);
      };
      resize();
      this._fxResize = resize;
      window.addEventListener("resize", resize);
      this._fxRaf = requestAnimationFrame(tick);
    },
    stopScene() {
      if (this._fxRaf) {
        cancelAnimationFrame(this._fxRaf);
        this._fxRaf = null;
      }
      if (this._fxResize) {
        window.removeEventListener("resize", this._fxResize);
        this._fxResize = null;
      }
    },
    //获取登录页log
    init(){
      let that = this;
      httpApi
        .listParams({
          params: {
            type: "sys_config",
            enable: "1",
          },
        })
        .then((res) => {
          if (res.data.code == "ok" && res.data.data && res.data.data.length > 0) {
            that.logoUrl = res.data.data[0].logoPortalUrl;
            that.title = res.data.data[0].title;
            that.record = res.data.data[0].record;
            that.company = res.data.data[0].company;
            saveSysBrand(res.data.data[0]);
            applyDocumentTitle("用户登录");
          } else {
            console.warn("获取系统配置失败或无数据");
          }
        })
        .catch((error) => {
          console.error("获取系统配置异常:", error);
          that.$message.error("获取系统配置失败，请稍后重试");
        });
    },
    initWeixin(){
      return new Promise((resolve, reject) => {
        let that = this;
        httpApi
          .listParams({
            params: {
              type: "sys_weixin",
              enable: "1",
            },
          })
          .then((res) => {
            const weixinConfig = pickWebsiteWeiXin(res.data.data);
            if (res.data.code == "ok" && weixinConfig && weixinConfig.appid && weixinConfig.encodeUrl) {
              that.redirect_uri = encodeURIComponent("http://" + weixinConfig.encodeUrl + "/login");
              that.appid = weixinConfig.appid;
              that.wxConfigAvailable = true;
            } else {
              that.wxConfigAvailable = false;
              console.warn("未配置微信网站应用，或缺少 appid / 授权回调域");
            }
            resolve();
          })
          .catch((error) => {
            that.wxConfigAvailable = false;
            console.error("获取微信配置异常:", error);
            reject(error);
          });
      });
    },
    submitLogin(formName) {
      let that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          //登录
          httpApi
            .submitLogin({
              account: that.ruleForm.tel,
              password: that.ruleForm.pass
            })
            .then(res => {
              if (res.data.code == "ok") {
                //令牌存储到临时缓存
                sessionStorage.setItem("token", res.data.data.token);
                // localStorage.setItem("refToken", res.data.data.refreshToken);
                //登录成功
                // that.$message.success("登录成功！");
                //跳转首页
                that.$router.push("/");
              } else {
                that.$message.error(res.data.message || "登录失败，请检查账号密码");
              }
            })
            .catch((error) => {
              console.error("登录请求异常:", error);
              that.$message.error("登录请求失败，请稍后重试");
            });
        } else {
          return false;
        }
      });
    },
    /** 从 URL 取快捷登录 token（勿用微信 OAuth 的 code） */
    pickFastLoginToken() {
      const params = new URLSearchParams(window.location.search || '');
      // 系统配置一键登录网址历史为 ?getToken=；亦兼容 token / fastToken
      const fromSearch =
        params.get('getToken') ||
        params.get('token') ||
        params.get('fastToken');
      if (fromSearch) {
        return fromSearch;
      }
      const q = (this.$route && this.$route.query) || {};
      return q.getToken || q.token || q.fastToken || '';
    },
    fastLogin() {
      let that = this;
      const urlToken = this.pickFastLoginToken();
      if (urlToken) {
        httpApi.fastLogin({ token: urlToken }).then(res => {
          if (res.data.code == "ok") {
            sessionStorage.setItem("token", res.data.data.token);
            localStorage.setItem("refToken", res.data.data.refreshToken);
            if (window.history && window.history.replaceState) {
              const cleanUrl = window.location.pathname + window.location.hash;
              window.history.replaceState({}, document.title, cleanUrl);
            }
            that.$router.push("/");
          } else {
            that.$message.error(res.data.message || "自动登录失效！");
          }
        }).catch((error) => {
          console.error("快速登录异常:", error);
          that.$message.error("快速登录失败，请稍后重试");
        });
      }
      
      // 加载图标和标题配置
      httpApi
        .listParams({
          params: {
            type: "sys_config",
            enable:"1"
          }
        })
        .then(ress => {
          if (ress.data.code == "ok" && ress.data.data && ress.data.data.length > 0) {
            saveSysBrand(ress.data.data[0]);
            applyDocumentTitle("用户登录");
          } else {
            console.warn("获取配置失败或无数据");
          }
        })
        .catch((error) => {
          console.error("获取配置异常:", error);
        });
    },
    openWxLoginDialog() {
      if (!this.wxConfigAvailable) {
        this.$message.warning("微信扫码暂未开通，请联系管理员配置网站应用");
        return;
      }
      this.msgDialogVisible = true;
    },
    wxLogin() {
      if (!this.wxConfigAvailable) {
        console.warn("微信配置不可用，跳过微信登录");
        return;
      }
      
      if (this.code && this.code.trim()) {
        //登录
        httpApi
          .wxLogin({
            params: {
              code: this.code
            }
          })
          .then(res => {
            if (res.data.code == "ok") {
              //令牌存储到临时缓存
              sessionStorage.setItem("token", res.data.data.token);
              // localStorage.setItem("refToken", res.data.data.refreshToken);
              //登录成功
              // that.$message.success("登录成功！");
              //跳转首页
              this.$router.push("/");
            } else {
              this.$message.error(res.data.message || "微信登录失败");
            }
          })
          .catch((error) => {
            console.error("微信登录异常:", error);
            this.$message.error("微信登录请求失败，请稍后重试");
          });
      }
    }
  },
  mounted() {
    this.syncSceneTheme();
    this._themeTimer = setInterval(() => this.syncSceneTheme(), 60000);
    this.$nextTick(() => this.startScene());
  },
  created() {
    this.code = this.$route.query.code;
    this.init();
    // 快捷登录 token 仅约 20 秒有效：有 getToken/token 时立刻换票，勿等微信配置
    const hasFastToken = !!this.pickFastLoginToken();
    if (hasFastToken) {
      this.fastLogin();
      this.initWeixin().catch(() => {});
    } else if (this.code) {
      // 微信 OAuth：等配置就绪再换票
      this.initWeixin()
        .then(() => this.wxLogin())
        .catch(() => {});
    } else {
      this.initWeixin().catch(() => {});
      this.fastLogin();
    }

    //回车键直接登录
    const that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      //需要注意的：that.$route.path==''/login'的作用是如果不判断，回车可能所有页面都生效，也就是无论在哪个页面敲回车都会直接登录
      if (that.$route.path == "/login" && keycode == 13) {
        that.submitLogin("ruleForm");
        return false;   
      }
    };
  },
  beforeDestroy() {
    this.stopScene();
    if (this._themeTimer) {
      clearInterval(this._themeTimer);
      this._themeTimer = null;
    }
    // 销毁事件监听，防止内存泄漏
    document.onkeypress = null;
  }
};
</script>
<style lang="less" scoped>
.login {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 28px 6vw;
  color: #e0f2fe;
  background:
    radial-gradient(900px 520px at 16% 78%, rgba(14, 165, 233, 0.22), transparent 62%),
    radial-gradient(680px 420px at 86% 8%, rgba(245, 158, 11, 0.12), transparent 58%),
    linear-gradient(165deg, #020617 0%, #071425 48%, #020617 100%);
}

.scene {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}

.aurora {
  position: absolute;
  width: 520px;
  height: 520px;
  border-radius: 50%;
  filter: blur(40px);
  opacity: 0.55;
}

.aurora-a {
  left: -80px;
  bottom: -120px;
  background: radial-gradient(circle, rgba(34, 211, 238, 0.35), transparent 68%);
  animation: drift 14s ease-in-out infinite;
}

.aurora-b {
  right: 8%;
  top: -160px;
  background: radial-gradient(circle, rgba(245, 158, 11, 0.22), transparent 70%);
  animation: drift 18s ease-in-out infinite reverse;
}

.grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(56, 189, 248, 0.08) 1px, transparent 1px),
    linear-gradient(90deg, rgba(56, 189, 248, 0.08) 1px, transparent 1px);
  background-size: 52px 52px;
  mask-image: radial-gradient(ellipse at 28% 62%, #000 10%, transparent 72%);
  animation: gridDrift 22s linear infinite;
}

.fx-canvas {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.floor {
  position: absolute;
  left: -20%;
  right: -10%;
  bottom: -28%;
  height: 58%;
  background:
    linear-gradient(rgba(34, 211, 238, 0.22) 1px, transparent 1px),
    linear-gradient(90deg, rgba(34, 211, 238, 0.22) 1px, transparent 1px);
  background-size: 64px 64px;
  transform: perspective(460px) rotateX(64deg);
  transform-origin: center top;
  mask-image: linear-gradient(transparent, #000 24%, #000 72%, transparent);
  animation: floorMove 7s linear infinite;
}

.scanline {
  position: absolute;
  left: 0;
  right: 0;
  height: 140px;
  background: linear-gradient(transparent, rgba(34, 211, 238, 0.09), transparent);
  animation: sweep 8s linear infinite;
}

.stage-wrap {
  position: absolute;
  left: 2vw;
  bottom: 3vh;
  width: ~"min(740px, 56vw)";
  z-index: 1;
}

.stage {
  width: 100%;
  height: auto;
  display: block;
  filter: drop-shadow(0 18px 30px rgba(2, 6, 23, 0.45));
}

.vignette {
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at 72% 48%, transparent 0%, rgba(2, 6, 23, 0.18) 46%, rgba(2, 6, 23, 0.78) 100%);
}

.story {
  position: absolute;
  z-index: 2;
  left: 6vw;
  top: 8vh;
  max-width: 460px;
  pointer-events: none;

  .eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    letter-spacing: 0.22em;
    font-size: 12px;
    color: #67e8f9;
    border: 1px solid rgba(103, 232, 249, 0.35);
    border-radius: 999px;
    padding: 6px 12px;
    background: rgba(8, 47, 73, 0.45);
  }

  h2 {
    margin: 16px 0 10px;
    font-size: 40px;
    line-height: 1.25;
    font-weight: 700;
    color: #f0f9ff;
    text-shadow: 0 0 28px rgba(34, 211, 238, 0.28);
  }

  p {
    margin: 0;
    max-width: 380px;
    color: #bae6fd;
    font-size: 15px;
    line-height: 1.7;
  }
}

.hud {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 22px;

  div {
    min-width: 108px;
    padding: 10px 12px;
    border-radius: 12px;
    background: rgba(6, 20, 40, 0.62);
    border: 1px solid rgba(125, 211, 252, 0.28);
    box-shadow: inset 0 0 18px rgba(14, 165, 233, 0.08);
  }

  em {
    display: block;
    font-style: normal;
    font-size: 11px;
    letter-spacing: 0.08em;
    color: #7dd3fc;
  }

  strong {
    display: block;
    margin-top: 4px;
    font-size: 14px;
    color: #f8fafc;
  }
}

.main-shell {
  position: relative;
  z-index: 3;
  width: ~"min(440px, calc(100vw - 32px))";
  padding: 1px;
  border-radius: 22px;
  flex: 0 0 auto;
}

.shell-spin {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  overflow: hidden;
  pointer-events: none;

  &:before {
    content: "";
    position: absolute;
    inset: -60%;
    background: conic-gradient(from 0deg, rgba(34, 211, 238, 0.05), #22d3ee, rgba(245, 158, 11, 0.85), rgba(34, 211, 238, 0.05), #38bdf8);
    animation: spin 8s linear infinite;
  }
}

.main-box {
  position: relative;
  z-index: 1;
  border-radius: 21px;
  background: rgba(5, 16, 34, 0.82);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45), inset 0 0 40px rgba(14, 165, 233, 0.06);
  backdrop-filter: blur(18px);
  padding: 28px 28px 18px;
  max-height: calc(100vh - 120px);
  overflow: auto;

  &:before,
  &:after {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    border: 2px solid #22d3ee;
    pointer-events: none;
  }

  &:before {
    top: 12px;
    left: 12px;
    border-right: 0;
    border-bottom: 0;
  }

  &:after {
    right: 12px;
    bottom: 12px;
    border-left: 0;
    border-top: 0;
  }
}

.brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 8px;

  h1 {
    margin: 8px 0 0;
    font-size: 22px;
    line-height: 1.35;
    font-weight: 700;
    color: #f0f9ff;
    text-align: center;
  }
}

.logo-plate {
  background: rgba(255, 255, 255, 0.94);
  border-radius: 12px;
  padding: 8px 16px;
  margin-bottom: 6px;

  img {
    display: block;
    max-width: 220px;
    max-height: 72px;
    object-fit: contain;
  }
}

.logo-mark {
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  margin-bottom: 8px;
  background: rgba(8, 47, 73, 0.65);
  border: 1px solid rgba(103, 232, 249, 0.4);
  box-shadow: 0 0 24px rgba(34, 211, 238, 0.25);

  svg {
    width: 40px;
    height: 40px;
  }
}

.status {
  margin-top: 8px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #a5f3fc;

  i {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #22d3ee;
    box-shadow: 0 0 10px #22d3ee;
    animation: core 1.6s ease-in-out infinite;
  }
}

.main-login {
  margin-top: 12px;
}

.userLogin {
  font-size: 14px;

  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  /deep/ .el-form-item {
    margin-bottom: 18px;
  }

  /deep/ .el-input--medium .el-input__inner {
    height: 46px;
    line-height: 46px;
    font-size: 14px;
    border-radius: 12px;
    border: 1px solid rgba(56, 189, 248, 0.35);
    background: rgba(2, 12, 28, 0.72);
    color: #e0f2fe;
    color-scheme: dark;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:focus {
      border-color: #22d3ee;
      box-shadow: 0 0 0 3px rgba(34, 211, 238, 0.16);
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active,
    &:autofill,
    &:autofill:hover,
    &:autofill:focus {
      -webkit-text-fill-color: #e0f2fe !important;
      caret-color: #e0f2fe;
      color-scheme: dark;
      background-color: #071422 !important;
      background-image: none !important;
      box-shadow: 0 0 0 1000px #071422 inset !important;
      transition: background-color 99999s ease-out 0s;
    }
  }

  /deep/ .el-input__inner::placeholder {
    color: rgba(186, 230, 253, 0.55);
  }

  /deep/ .el-input__prefix,
  /deep/ .el-input__suffix,
  /deep/ .el-input__icon {
    color: #67e8f9;
  }

  .el-button--primary {
    width: 100% !important;
    height: 46px;
    margin: 4px 0 0 !important;
    border: none;
    border-radius: 12px;
    color: #042f3a;
    font-weight: 700;
    font-size: 16px;
    letter-spacing: 0.12em;
    background: linear-gradient(90deg, #22d3ee, #38bdf8 45%, #fbbf24);
    box-shadow: 0 8px 24px rgba(34, 211, 238, 0.28);

    /deep/ span {
      font-size: 16px;
      color: #042f3a;
    }

    &:hover,
    &:focus {
      color: #042f3a;
      transform: translateY(-1px);
      box-shadow: 0 10px 28px rgba(34, 211, 238, 0.4);
    }
  }
}

.registered {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 36px;
  color: #7dd3fc;

  .registered_left,
  .registered_r {
    float: none;
    margin: 0;
    cursor: pointer;
    color: #7dd3fc;
  }
}

.wx-login-title {
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;

  strong {
    display: block;
    font-size: 16px;
    font-weight: 700;
    color: #f0f9ff;
    letter-spacing: 0.06em;
  }

  em {
    display: block;
    margin-top: 2px;
    font-style: normal;
    font-size: 12px;
    color: #7dd3fc;
  }
}

.wx-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 10px #22c55e;
  flex: 0 0 auto;
}

.wx-login-frame {
  position: relative;
  width: 300px;
  height: 400px;
  margin: 0 auto;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;

  /deep/ iframe {
    display: block;
    position: relative;
    z-index: 1;
    background: #fff;
  }
}

.wx-login-loading {
  position: absolute;
  inset: 0;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 13px;
}

.wx-config-error {
  color: #bae6fd;
  text-align: center;
  line-height: 1.6;
  padding: 28px 8px 12px;
  font-size: 14px;
}

/deep/ .wx-login-dialog {
  background: rgba(6, 16, 34, 0.96);
  border: 1px solid rgba(125, 211, 252, 0.4);
  border-radius: 18px;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.55), 0 0 32px rgba(34, 211, 238, 0.12);
  overflow: hidden;

  .el-dialog__header {
    padding: 16px 44px 10px 18px;
  }

  .el-dialog__headerbtn {
    top: 16px;
    right: 16px;
  }

  .el-dialog__close {
    color: #7dd3fc;
    font-size: 18px;
  }

  .el-dialog__body {
    padding: 0 18px 18px;
  }
}

.footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 18px;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #dbeafe;
  font-size: 13px;
  line-height: 1.6;
  text-shadow: 0 1px 8px rgba(2, 6, 23, 0.8);
  pointer-events: none;

  p,
  a {
    margin: 0;
    font-size: 13px;
  }

  a {
    pointer-events: auto;
    color: inherit;
    text-decoration: none;

    &:hover {
      color: #67e8f9;
    }
  }
}


.beam {
  fill: rgba(34, 211, 238, 0.9);
  animation: rackScan 3.4s ease-in-out infinite;
}

.b2 { animation-delay: 0.8s; }
.b3 { animation-delay: 1.6s; }

.crate {
  animation: cratePulse 3s ease-in-out infinite;
}

.crate:nth-of-type(2n) { animation-delay: 0.7s; }

.belt-dash {
  animation: dash 0.8s linear infinite;
}

.parcel {
  animation: ride 8s linear infinite;
}

.parcel.d2 { animation-delay: -2.6s; }
.parcel.d3 { animation-delay: -5.2s; }

.robot {
  animation: patrol 9s ease-in-out infinite;
}

.arm {
  transform-box: fill-box;
  transform-origin: 0% 50%;
  animation: reach 1.6s ease-in-out infinite;
}

.core,
.visor {
  animation: core 1.8s ease-in-out infinite;
}

.sweep-arm {
  transform-box: fill-box;
  transform-origin: 0% 50%;
  animation: spin 3s linear infinite;
}

.truck {
  animation: drive 16s linear infinite;
}

@keyframes drift {
  0%, 100% { transform: translate3d(0, 0, 0); }
  50% { transform: translate3d(30px, -24px, 0); }
}

@keyframes gridDrift {
  from { background-position: 0 0; }
  to { background-position: 52px 52px; }
}

@keyframes floorMove {
  from { background-position: 0 0; }
  to { background-position: 0 64px; }
}

@keyframes sweep {
  from { top: -140px; }
  to { top: 100%; }
}

@keyframes rackScan {
  0% { transform: translateY(0); opacity: 0; }
  12% { opacity: 1; }
  88% { opacity: 0.85; }
  100% { transform: translateY(210px); opacity: 0; }
}

@keyframes cratePulse {
  0%, 100% { opacity: 0.55; }
  50% { opacity: 1; }
}

@keyframes dash {
  to { stroke-dashoffset: -28; }
}

@keyframes ride {
  0% { transform: translateX(0); opacity: 0; }
  8% { opacity: 1; }
  92% { opacity: 1; }
  100% { transform: translateX(470px); opacity: 0; }
}

@keyframes patrol {
  0%, 100% { transform: translate(48px, 236px); }
  50% { transform: translate(430px, 236px); }
}

@keyframes reach {
  0%, 100% { transform: rotate(10deg); }
  50% { transform: rotate(-22deg); }
}

@keyframes core {
  0%, 100% { opacity: 0.45; }
  50% { opacity: 1; }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes drive {
  from { transform: translate(-180px, 430px); }
  to { transform: translate(780px, 430px); }
}

.login.is-day {
  color: #0c4a6e;
  background:
    radial-gradient(900px 520px at 12% 86%, rgba(56, 189, 248, 0.38), transparent 60%),
    radial-gradient(720px 460px at 88% 0%, rgba(251, 191, 36, 0.32), transparent 58%),
    linear-gradient(165deg, #f4fbff 0%, #e0f2fe 48%, #f8fafc 100%);

  .aurora { opacity: 0.9; }
  .aurora-a { background: radial-gradient(circle, rgba(14, 165, 233, 0.42), transparent 68%); }
  .aurora-b { background: radial-gradient(circle, rgba(245, 158, 11, 0.34), transparent 70%); }

  .grid {
    background-image:
      linear-gradient(rgba(14, 116, 144, 0.16) 1px, transparent 1px),
      linear-gradient(90deg, rgba(14, 116, 144, 0.16) 1px, transparent 1px);
  }

  .floor {
    background:
      linear-gradient(rgba(2, 132, 199, 0.28) 1px, transparent 1px),
      linear-gradient(90deg, rgba(2, 132, 199, 0.28) 1px, transparent 1px);
  }

  .scanline {
    background: linear-gradient(transparent, rgba(14, 165, 233, 0.16), transparent);
  }

  .vignette {
    background: radial-gradient(ellipse at 72% 48%, transparent 0%, rgba(255, 255, 255, 0.12) 52%, rgba(224, 242, 254, 0.82) 100%);
  }

  .story {
    .eyebrow {
      color: #0369a1;
      border-color: rgba(14, 165, 233, 0.45);
      background: rgba(255, 255, 255, 0.76);
    }
    h2 {
      color: #0c4a6e;
      text-shadow: none;
    }
    p { color: #155e75; }
  }

  .hud div {
    background: rgba(255, 255, 255, 0.82);
    border-color: rgba(14, 165, 233, 0.35);
    box-shadow: none;
  }
  .hud em { color: #0369a1; }
  .hud strong { color: #0f172a; }

  .main,
  .main-box {
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 24px 60px rgba(14, 116, 144, 0.14);
  }

  .logo-title,
  .brand h1 { color: #0c4a6e; }
  .logo-sub,
  .status { color: #0369a1; }
  .logo-mark {
    background: rgba(224, 242, 254, 0.95);
    border-color: rgba(14, 165, 233, 0.4);
  }

  .userLogin,
  .smsVerify {
    /deep/ .el-input--medium .el-input__inner {
      background: rgba(255, 255, 255, 0.96);
      color: #0f172a;
      color-scheme: light;
      border-color: rgba(14, 165, 233, 0.45);

      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active,
      &:autofill,
      &:autofill:hover,
      &:autofill:focus {
        -webkit-text-fill-color: #0f172a !important;
        caret-color: #0f172a;
        color-scheme: light;
        background-color: #f8fafc !important;
        background-image: none !important;
        box-shadow: 0 0 0 1000px #f8fafc inset !important;
        transition: background-color 99999s ease-out 0s;
      }
    }
    /deep/ .el-input__inner::placeholder { color: rgba(12, 74, 110, 0.45); }
    /deep/ .el-input__prefix,
    /deep/ .el-input__suffix,
    /deep/ .el-input__icon { color: #0284c7; }
    .input-icon {
      background: rgba(224, 242, 254, 0.95);
      border-color: rgba(14, 165, 233, 0.4);
      i { color: #0284c7; }
    }
    .password-toggle,
    .el-button--text { color: #0369a1; }
  }

  .remember-password {
    /deep/ .el-checkbox__label { color: #155e75; }
    /deep/ .el-checkbox__inner {
      background: #fff;
      border-color: rgba(14, 165, 233, 0.65);
    }
  }

  .smsVerify .verify-title {
    h3 { color: #0c4a6e; }
    p { color: #155e75; }
  }

  .registered,
  .registered .registered_left,
  .registered .registered_r { color: #0369a1; }

  .footer {
    color: #0c4a6e;
    text-shadow: none;
    a:hover { color: #0369a1; }
  }
}

.wx-login-title.is-day {
  strong { color: #0c4a6e; }
  em { color: #0369a1; }
}

/deep/ .wx-login-dialog.is-day {
  background: rgba(255, 255, 255, 0.97);
  border-color: rgba(14, 165, 233, 0.45);
  box-shadow: 0 24px 60px rgba(14, 116, 144, 0.18);

  .el-dialog__close { color: #0369a1; }
}

@media (min-width: 1280px) {
  .login {
    padding-right: ~"max(6vw, calc((100vw - 1440px) / 2))";
  }

  .story,
  .stage-wrap {
    left: ~"max(6vw, calc((100vw - 1440px) / 2))";
  }
}

@media (max-width: 1080px) {
  .story,
  .stage-wrap {
    display: none;
  }

  .login {
    justify-content: center;
    padding: 16px;
  }
}

@media (max-height: 760px) {
  .story h2 {
    font-size: 30px;
  }

  .stage-wrap {
    width: ~"min(560px, 50vw)";
  }
}

</style>
